import React, {useState, useEffect} from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import DashboardFatturato from "../../../components/dashboard/DashboardFatturato";
import DashboardProdotti from "../../../components/dashboard/DashboardProdotti";
import '../../../../node_modules/react-vis/dist/style.css';
import getProdotti from "../../../services/getProdotti";
import getAgenti from "../../../services/getAgenti";
import getFunzionari from "../../../services/getFunzionari";
import getClientiAnagrafica from "../../../services/getClientiAnagrafica";
import Cookies from "universal-cookie";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

const DashboardCommerciale = () => {

    const [prodotti, setProdotti] = useState([]);
    const [segnalatori, setSegnalatori] = useState([]);
    const [agenti, setAgenti] = useState([]);
    const [funzionari, setFunzionari] = useState([]);
    const [province, setProvince] = useState([]);
    const [regioni, setRegioni] = useState([]);
    const [clienti, setClienti] = useState([]);

    const getProdottiServ = async () => {
        const response = await getProdotti(username, token);
        if(response) {
            setProdotti(response);
        }
    };

    const getAgentiServ = async () => {
        const response = await getAgenti(username, token);
        if(response) {
            setAgenti(response);
            setSegnalatori(response);
        }
    };

    const getFunzionariServ = async () => {
        const response = await getFunzionari(username, token);
        if(response) {
            setFunzionari(response);
        }
    };

    const getClientiAnagraficaServ = async () => {
        const response = await getClientiAnagrafica(username, token);
        if(response.status === 'ok') {
            setClienti(response.clienti);
            setProvince(response.province);
            setRegioni(response.regioni);
        }
    };

    useEffect(() => {
        getProdottiServ();
        getClientiAnagraficaServ();
        getAgentiServ();
        getFunzionariServ();

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });

    }, []);

    return (
        <>
            <PageTitle title={'Dashboard'} />
            <DashboardFatturato
                username={username}
                token={token}
                clienti={clienti}
                prodotti={prodotti}
                agenti={agenti}
                funzionari={funzionari}
                segnalatori={segnalatori}
                regioni={regioni}
                province={province}
            />
            <DashboardProdotti
                username={username}
                token={token}
                clienti={clienti}
                prodotti={prodotti}
                agenti={agenti}
                funzionari={funzionari}
                segnalatori={segnalatori}
                regioni={regioni}
                province={province}
            />
        </>
    );
}

export default DashboardCommerciale;
                        